'use client';

import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, List, ListItem, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import cn from './style.module.scss';
export default function OgamiAmenities(props: MarketingPageComponentProps) {
  const amenitiesSection = props?.locale?.section?.find(
    (section: any) => section.type === 'amenities' && section.enabled
  );
  if (!amenitiesSection) return null;
  const ogamiAmenitiesElementList = amenitiesSection?.ogamiAmenitiesData ?? [];
  return (
    <Stack component="section" className={cn.ogamiAmenitiesWrapper}>
      <Box className={cn.ogamiAmenitiesInner}>
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.ogamiAmenitiesBlock}>
            <List className={cn.ogamiAmenitiesList}>
              {ogamiAmenitiesElementList.map((feature: any, index: number) => (
                <ListItem key={index} className={cn.ogamiAmenitiesItem}>
                  <Box
                    className={cn.ogamiAmenitiesElement}
                    {...mergeAos(fadeUpAosProps, getAosDelay(200 + index * 5))}
                  >
                    <Box className={cn.ogamiAmenitiesIcon}>
                      <CustomImage
                        src={feature.icon}
                        alt={feature.alt}
                        width={40}
                        height={40}
                      />
                    </Box>
                    <Box className={cn.ogamiAmenitiesTitle}>
                      <ParallaxText
                        variant="p"
                        animationType="zoomIn"
                        animationDuration={500}
                      >
                        {ReactHtmlParser(feature.title)}
                      </ParallaxText>
                    </Box>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
